module.exports = __webpack_public_path__ + "static/img/kid-main-b.a96b98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-main-b.png
// module id = FFHz
// module chunks = 0